export function buildMinistryReportStats({ students, visitLogs, finances }) {
    const now = Date.now();
    const thirtyDaysAgo = new Date(now - 30 * 24 * 60 * 60 * 1000);
    const recentVisitCount = visitLogs.filter((log) => new Date(log.date) > thirtyDaysAgo).length;
    const financeBalance = finances.reduce((acc, item) => acc + (item.type === "income" ? item.amount : -item.amount), 0);

    return {
        studentCount: students.length,
        studentDelta: 0,
        attendanceRate: 0,
        attendanceDelta: 0,
        visitationCount: recentVisitCount,
        visitationRate: students.length > 0 ? Math.round((recentVisitCount / students.length) * 100) : 0,
        financeBalance,
        financeDelta: 0,
        absentees: []
    };
}
